module.exports = "/_next/static/images/mk-f26a783009c5b42ff3d9dcdcbd167254.svg";